import { render } from "./vgpSvgImage.vue?vue&type=template&id=c756da92&scoped=true"
import script from "./vgpSvgImage.vue?vue&type=script&lang=js"
export * from "./vgpSvgImage.vue?vue&type=script&lang=js"

import "./vgpSvgImage.vue?vue&type=style&index=0&id=c756da92&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c756da92"]])

export default __exports__